// extracted by mini-css-extract-plugin
export default {"label":"store-finder-icon-label--cbe69","link":"store-finder-icon-link--f2e03"};